export default "__VITE_ASSET__s6WnQbY5__"